import React from "react";
import { Col, Modal, Row } from "antd";
import "../../../../assets/style/modalStyle/postNews.scss";
import { useDispatch, useSelector } from "react-redux";
import TranslateText from "../../TranslateText";
import imageLogo from "../../../../assets/images/image 9.png";
import "../../../../assets/style/modalStyle/detailNews.scss";

import InputText from "../../Input/InputText";
import LabelInput from "../../LabelInput";
import moment from "moment";
import { IconLock } from "../../../../assets/icon";
const ModalPreviewPost = ({ open, setOpen, data }) => {
  const handCancel = () => {
    setOpen(false);
  };
  return (
    <>
      <Modal
        maskClosable={false}
        title={<TranslateText text="Xem trước bài viết" />}
        centered
        width={931}
        open={open}
        onCancel={handCancel}
        footer={[]}
        style={{ minHeight: "50%" }}
      >
        {data.content ? (
          <div className="wrapperContentDetail ">
            <div className="titleDetail" style={{ marginLeft: 0 }}>
              <img src={imageLogo} alt="logo" />
              <p>
                <h1>{data.title}</h1>
                <span id="time">
                  <span> {moment(data.time).format("DD/MM/YYYY")}</span>
                </span>
              </p>
            </div>
            {data.typePost === 1 ? (
              <div
                className="contentDetail"
                dangerouslySetInnerHTML={{
                  __html: data.content.replace(
                    new RegExp(window.SERVER_CLIENT_URL, "g"),
                    window.SERVER_URL
                  ),
                }}
              ></div>
            ) : (
              <>
                <Row style={{ margin: "1.5rem 0" }} align="middle">
                  <Col span={2}>
                    <LabelInput text={"Link bài viết"} />
                  </Col>
                  <Col span={16}>
                    <InputText
                      disable
                      text={data.content.replace(
                        new RegExp(window.SERVER_CLIENT_URL, "g"),
                        window.SERVER_URL
                      )}
                    />
                  </Col>
                </Row>
                <iframe
                  src={data.content}
                  width="100%"
                  height="400px"
                  title="W3Schools Free Online Web Tutorials"
                  frameborder="0"
                  allowfullscreen
                ></iframe>
              </>
            )}
          </div>
        ) : null}
      </Modal>
    </>
  );
};

export default ModalPreviewPost;
